import * as LDClient from 'launchdarkly-js-client-sdk';
import appConfig from 'appConfig';
import featureKeys from './featureKeys';

/**
 * Builds a service to access FeatureFlags
 */
export default (() => {
  let featureFlags = {};
  let _subscriptions = [];
  let ldclient = null;

  async function initializeFeatureFlags(user) {
    if (ldclient) {
      ldclient.close();
    }
    const ldOptions = {
      evaluationReasons: true,
    };

    let ldUser = { anonymous: true };
    if (user) {
      const accountId = user.accountId || '';
      ldUser = { key: accountId };
    }
    ldclient = LDClient.initialize(appConfig.getLaunchDarklyClientId(), ldUser, ldOptions);

    try {
      await ldclient.waitForInitialization();
      featureFlags = ldclient.allFlags();
    } catch (error) {
      throw new Error('Failed to initialize feature flags.', error);
    }


    ldclient.on('change', (updatedFlagDetails) => {
      const key = Object.keys(updatedFlagDetails)[0];
      featureFlags[key] = updatedFlagDetails[key].current;
      notifyListeners(key);
    });
  }

  function notifyListeners(featureFlagThatChanged) {
    _subscriptions.forEach((item) => {
      if (item.flag === featureFlagThatChanged) {
        item.callback(
          {
            flagName: featureFlagThatChanged,
            value: featureFlags[featureFlagThatChanged],
          }
        );
      }
    });
  }

  function unsubscribe(flag) {
    // This unsubscribe will unsubscribe everyone subscribed to this flag.
    _subscriptions = _subscriptions.filter((sub) => sub.flag !== flag);
  }

  function get() {
    return featureFlags;
  }

  function is(featureName) {
    return featureFlags[featureName];
  }

  function set(data) {
    const { name, isSet } = data;
    featureFlags[name] = isSet;
    notifyListeners(name);
    return featureFlags[name];
  }

  function subscribe(featureFlag, callbackFn) {
    const newSubscription = {
      flag: featureFlag,
      callback: callbackFn,
    };
    _subscriptions.push(newSubscription);
    return ((flag) => unsubscribe(flag));
  }

  return {
    initializeFeatureFlags,
    subscribe,
    get,
    is,
    set,
  };
})();

export { featureKeys };
